const _version = "3.1.4"
function version() {
    return _version
}
export default version
